import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import Banner from '../../atoms/Banner/Banner';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Grid } from '@material-ui/core';
import itemList from '../../../data/achievementsItemList.json';
import achievementsList from '../../../data/acievementList.json';
const bannerData = {
  imgSrc: '/images/image/footprint@2x.png',
  imgSrcM: '/images/image/foot print m@2x.png',
  title: 'Achievements',
  text1: 'Introducing the outstanding performances of trainees at the Best of the Best Center.',
};
const useStyles = makeStyles({
  bobAciveBox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },

  contents: {
    width: '1280px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: '106px',
  },
  divider: {
    width: '41px',
    height: '2px',
    backgroundColor: '#f4f6f9',
    marginBottom: '15px',
  },
  firstContents: {
    width: '640px',
    height: '194px',
    padding: '24px 45px 35px 24px',
    backgroundColor: '#191919',
    boxSizing: 'border-box',
    '@media only screen and (max-width: 1060px)': {
      width: '480px',
    },

    '@media only screen and (max-width: 816px)': {
      width: '450px',
    },

    '@media only screen and (max-width: 600px)': {
      width: '85%',
    },
  },

  firstText: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#f4f6f9',
    marginBottom: '24px',

    '@media only screen and (max-width: 1060px)': {
      fontSize: '18px',
    },
    '@media only screen and (max-width: 816px)': {
      fontSize: '16px',
    },

    '@media only screen and (max-width: 425px)': {
      fontSize: '14px',
    },
  },

  secondText: {
    fontSize: '16px',
    lineHeight: '1.25',
    textAlign: 'left',
    color: '#f4f6f9',
    '@media only screen and (max-width: 1060px)': {
      fontSize: '14px',
    },
    '@media only screen and (max-width: 816px)': {
      fontSize: '12px',
    },

    '@media only screen and (max-width: 425px)': {
      fontSize: '10px',
    },
  },

  secondContents: {
    width: '1064px',
    marginTop: '92px',
    backgroundColor: '#f4f6f9',
    '@media only screen and (max-width: 1060px)': {
      width: '800px',
    },

    '@media only screen and (max-width: 816px)': {
      width: '600px',
    },

    '@media only screen and (max-width: 600px)': {
      width: '100%',
    },
  },

  slidingBox: {
    height: '56px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  textBoldBox: {
    fontSize: '18px',
    fontWeight: 600,
    paddingBottom: '1px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '36px',
    justifyContent: 'center',

    '@media only screen and (max-width: 816px)': {
      fontSize: '16px',
      marginLeft: '28px',
    },

    '@media only screen and (max-width: 600px)': {
      marginLeft: '16px',
      fontSize: '14px',
    },

    '@media only screen and (max-width: 425px)': {
      fontSize: '12px',
      marginLeft: '8px',
    },
  },

  textBox: {
    fontSize: '16px',
    height: '24px',
    display: 'flex',
    marginTop: '0.5px',
    alignItems: 'center',
    marginLeft: '36px',
    '@media only screen and (max-width: 816px)': {
      fontSize: '14px',
      marginLeft: '28px',
    },

    '@media only screen and (max-width: 600px)': {
      fontSize: '12px',
      marginLeft: '16px',
    },
    '@media only screen and (max-width: 425px)': {
      fontSize: '10px',
      marginLeft: '8px',
    },
  },
  contentsBox: {
    display: 'flex',
    height: '100%',
  },

  item: {
    width: '50%',
    boxSizing: 'border-box',
    height: '306px',
    paddingLeft: '24px',
  },

  secondDivider: {
    width: '30px',
    height: '3px',
    marginTop: '36px',
    backgroundColor: 'black',
    marginBottom: '40px',
  },

  title: {
    fontSize: '20px',
  },
  subTitle: {
    fontSize: '20px',
    color: '#db350f',
  },

  text: {
    width: '200px',
    fontSize: '18px',
    marginTop: '12px',
  },

  subText: {
    fontSize: '14px',
    color: '#5a5a5a',
    marginTop: '20px',
  },

  yearBox: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2px',
  },

  backIcon: {
    '@media only screen and (max-width: 600px)': {
      width: '24px !important',
    },
    '@media only screen and (max-width: 425px)': {
      width: '16px !important',
    },
  },

  forwardIcon: {
    marginLeft: '36px',
    marginRight: '32px',
    '@media only screen and (max-width: 816px)': {
      marginLeft: '28px',
    },

    '@media only screen and (max-width: 600px)': {
      marginLeft: '16px',
      marginRight: '16px',
    },

    '@media only screen and (max-width: 425px)': {
      width: '16px !important',
    },
  },
});

export default function AchievementsPage() {
  const classes = useStyles();

  const [nowList, setNowList] = useState([]);
  const [gradeId, setGradeId] = useState(achievementsList.length - 1);

  useEffect(() => {
    let array = [];
    for (const i of achievementsList) {
      for (const d of itemList) {
        if (gradeId === i.id && i.year === d.year && i.generation === d.generation) {
          array.push(d);
        }
      }
    }

    setNowList(array);
  }, []);

  useEffect(() => {
    let array = [];
    for (const i of achievementsList) {
      for (const d of itemList) {
        if (gradeId === i.id && i.year === d.year && i.generation === d.generation) {
          array.push(d);
        }
      }
    }

    setNowList(array);
  }, [gradeId]);

  const handlePrevious = () => {
    if (gradeId === 0) {
      setGradeId(achievementsList.length - 1);
    } else setGradeId(gradeId - 1);
  };

  const handleNext = () => {
    if (gradeId + 1 === achievementsList.length) {
      setGradeId(0);
    } else setGradeId(gradeId + 1);
  };
  return (
    <Box className={classes.root}>
      <Banner bannerData={bannerData}></Banner>
      <Box className={classes.bobAciveBox}>
        <Box className={classes.contents}>
          <Box className={classes.firstContents}>
            <Box className={classes.divider}></Box>
            <Box className={classes.firstText}>BoB trainees are active in various competitions</Box>
            <Box className={classes.secondText}>
              -2014~2015 Korea White Hat Contest Junior/Senior Winner
              <br /> -International Hacking Defense Competition 2015 DEFCON Winner
              <br /> -2018 DEFCON Winner BoB trainees are active in various competitions
            </Box>
          </Box>
          <Box className={classes.secondContents}>
            <Box className={classes.slidingBox}>
              <ArrowBackIosIcon onClick={handlePrevious} className={classes.backIcon}></ArrowBackIosIcon>

              <Box className={classes.yearBox}>
                {gradeId === 0 ? (
                  <Box className={classes.textBox}>
                    {achievementsList[achievementsList.length - 1].year} {achievementsList[achievementsList.length - 1].generation}
                  </Box>
                ) : (
                  <Box className={classes.textBox}>
                    {achievementsList[gradeId - 1].year} {achievementsList[gradeId - 1].generation}
                  </Box>
                )}

                <Box className={classes.textBoldBox}>
                  {achievementsList[gradeId].year} {achievementsList[gradeId].generation}
                </Box>
                {gradeId + 1 === achievementsList.length ? (
                  <Box className={classes.textBox}>
                    {achievementsList[0].year} {achievementsList[0].generation}
                  </Box>
                ) : (
                  <Box className={classes.textBox}>
                    {achievementsList[gradeId + 1].year} {achievementsList[gradeId + 1].generation}
                  </Box>
                )}
              </Box>

              <ArrowForwardIosIcon onClick={handleNext} className={classes.forwardIcon}></ArrowForwardIosIcon>
            </Box>
            <Grid container className={classes.contentsBox}>
              {nowList.map((i, n) => {
                return (
                  <Grid key={n} xs={12} sm={6} md={6} item className={classes.item}>
                    <Box className={classes.secondDivider}></Box>
                    <Box className={classes.title}>{i.title}</Box>
                    <Box className={classes.subTitle}>{i.subTitle}</Box>
                    <Box className={classes.text}>{i.text}</Box>
                    <Box className={classes.subText}>{i.subText}</Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
